<template>
  <div class="location-wrapper clearfix" v-if="props.location">
    <div class="location-details tw-mb-4">
      <h3 class="tw-text-orange-medium tw-font-bold tw-text-2xl tw-mb-2"><a :href="'/menu/' + props.location.slug">{{props.location.name}}</a></h3>
      <p class="tw-mb-3">{{props.location.streetaddress}}<br>{{props.location.city}}, {{props.location.state}} </p>
      <p class="tw-mb-3"><b>P:</b> <a :href="'tel:'+props.location.phone" class="tw-underline">{{props.location.phone}}</a></p>
      <p>Open: {{locationHours}}</p>
    </div>
    <div>
      <button
        class="tw-bg-orange-medium tw-rounded-xl tw-uppercase tw-px-4 tw-py-2 tw-font-bold tw-text-xl tw-text-white hover:tw-bg-orange-dark hover:tw-text-white"
        @click="handleClick">
        Start Your Order
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    computed,
  } from 'vue';

import Location from '../../classes/Location';

import { DateTime } from 'luxon';

const props = defineProps({
  location: Location
})

const emit = defineEmits(['selectLocation'])

const locationHours = computed(() => {
  const calDay = props.location!.hoursForDay('business');
  const startDt = DateTime.fromFormat(calDay.start, 'yyyyMMdd HH:mm');
  const endDt = DateTime.fromFormat(calDay.end, 'yyyyMMdd HH:mm');

  return startDt.toFormat('h:mm a') + ' - ' + endDt.toFormat('h:mm a');
})

const handleClick = () => {
  emit('selectLocation', props.location);
}

</script>